/**
 * Coerce an unknown value to an array.
 *
 * `?? []` only covers `null` and `undefined`. It does nothing when a field arrives as `{}` or as a
 * `{ data: [...] }` wrapper, and `.map` then throws "x.map is not a function" and white-screens the
 * page. Since `api.ts` ends every request in `return json as T`, the compiler's belief about a
 * response shape is an assertion, not a check - so anything iterated at that boundary needs this.
 *
 * See .claude/rules/defensive-data-access.md. Use it on array props too: fixtures, tests and future
 * rewiring all bypass the call site that fetched the data.
 */
export function asArray<T>(value: unknown): T[] {
  if (Array.isArray(value)) return value as T[];
  if (value && typeof value === 'object') {
    for (const key of ['data', 'items', 'results'] as const) {
      const inner = (value as Record<string, unknown>)[key];
      if (Array.isArray(inner)) return inner as T[];
    }
  }
  return [];
}
